module.exports = {"TXTCLI_LoadingXX_Please_wait":{"id":"TXTCLI_LoadingXX_Please_wait","defaultMessage":"Chargement... Veuillez patienter"}}